(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var LEAVES = ['🍂', '🍁', '🍃'];
  var overlay = null;
  var stopped = false;

  function initLeaves() {
    overlay = document.createElement('div');
    overlay.className = 'bergkraft-leaves-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);

    var count = window.innerWidth < 768 ? 14 : 26;
    for (var i = 0; i < count; i++) {
      var leaf = document.createElement('span');
      leaf.className = 'bergkraft-leaf';
      leaf.textContent = LEAVES[Math.floor(Math.random() * LEAVES.length)];
      var size = 24 + Math.random() * 24;
      var left = Math.random() * 100;
      var fallDuration = 9 + Math.random() * 10;
      var swayDuration = 2.5 + Math.random() * 2;
      var delay = Math.random() * 12;
      var drift = Math.round(Math.random() * 70 + 20) + 'px';
      leaf.style.left = left + 'vw';
      leaf.style.fontSize = size + 'px';
      leaf.style.animationDuration = fallDuration + 's, ' + swayDuration + 's';
      leaf.style.animationDelay = '-' + delay + 's, 0s';
      leaf.style.setProperty('--drift', drift);
      overlay.appendChild(leaf);
    }
  }

  // Once the visitor starts scrolling, stop the falling-leaves effect: fade the
  // overlay out and remove it, instead of letting it keep falling over the content.
  function stopOnScroll() {
    if (stopped || !overlay) return;
    stopped = true;
    overlay.style.transition = 'opacity 0.6s ease';
    overlay.style.opacity = '0';
    window.setTimeout(function () {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 700);
    window.removeEventListener('scroll', stopOnScroll);
  }

  function start() {
    initLeaves();
    window.addEventListener('scroll', stopOnScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
